import { createFileRoute } from '@tanstack/react-router';
import { SEO } from '@/components/SEO';
import { ScenarioSwapDemo } from '@/components/poc/ScenarioSwapDemo';

function SwapRoute() {
  const { hero } = Route.useSearch();
  return (
    <>
      <SEO
        title='Scenario swap POC'
        description='Same phone frame, swappable scenario scenes.'
        path='/poc/swap'
        noindex
      />
      <ScenarioSwapDemo hero={hero} />
    </>
  );
}

export const Route = createFileRoute('/poc/swap')({
  component: SwapRoute,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      hero: (search.hero as string) || undefined,
    };
  },
});
